import { QueryClient } from '@tanstack/react-query'

// One QueryClient instance for the app. Field managers open this in short
// bursts (check a placeholder screen, sign out) so keep data reasonably fresh
// but still avoid refetch storms on window focus (mobile browsers fire focus
// events aggressively on app-switch).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30s
      gcTime: 5 * 60_000, // 5 min in memory
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
